import React from 'react';
import { Row, Col } from 'react-bootstrap5';

export default function Index() {
  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-affiliates-training-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-5">Certification Training</h1>

            <p>
              Thank you for your patience. We&apos;re currently reviewing your request.
              Once approved, you&apos;ll gain full access to our Affiliate Sales Training content.
            </p>

            <p>
              Click the Chat Widget on the bottom of the screen to ask any questions in the meantime.
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
}
